var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3784 14.918H11.5996L14.4227 19.0692L17.2457 14.918H14.3784Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9116 20.4396C26.1606 17.2734 23.3144 14.918 19.9183 14.918H19.7966L14.4227 22.8197L9.04797 14.918H8.83844C4.86859 14.918 1.65039 18.1362 1.65039 22.106V31.9891H19.1884C18.9065 31.1194 18.7609 30.2011 18.7609 29.2603C18.7609 26.8971 19.6813 24.6752 21.3527 23.0039C22.858 21.4978 24.8113 20.602 26.9116 20.4396Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3789 0C10.2593 0 6.91943 3.33984 6.91943 7.45945C6.91943 10.17 8.36576 12.543 10.5279 13.8488C10.7065 13.9563 10.8893 14.0569 11.077 14.149C12.0719 14.6419 13.1934 14.9182 14.3789 14.9182C15.6185 14.9182 16.7878 14.6159 17.8158 14.0808C17.9726 13.9999 18.1265 13.9127 18.2763 13.8199C20.4131 12.5086 21.8383 10.151 21.8383 7.45945C21.8383 3.33984 18.4985 0 14.3789 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 24.9638C33.1762 24.7725 31.185 22.5 28.125 22.5C24.4013 22.5 21.375 25.5263 21.375 29.25C21.375 32.9738 24.4013 36 28.125 36C31.8488 36 34.875 32.9738 34.875 29.25C34.875 27.0113 33.6825 25.38 33.3337 24.9638ZM30.375 30.375H29.25V31.5C29.25 32.1187 28.7438 32.625 28.125 32.625C27.5062 32.625 27 32.1187 27 31.5V30.375H25.875C25.2562 30.375 24.75 29.8688 24.75 29.25C24.75 28.6312 25.2562 28.125 25.875 28.125H27V27C27 26.3812 27.5062 25.875 28.125 25.875C28.7438 25.875 29.25 26.3812 29.25 27V28.125H30.375C30.9937 28.125 31.5 28.6312 31.5 29.25C31.5 29.8688 30.9937 30.375 30.375 30.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH3);
export default __webpack_public_path__ + "static/media/h3.54f1d0a08541e4dea13cbe50a984565a.svg";
export { ForwardRef as ReactComponent };